import React, { useState, useRef, useEffect } from 'react';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Badge
} from '@chakra-ui/react';
import { FormattedDate, FormattedTime, FormattedNumber } from 'react-intl';
import NoDataPage from '../../../components/NoData';

function MedicineHistoryModal({ 
    medicine_name, medicineImportExportList, initialRef, isOpen, onClose
}) {
    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="xxl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Flex>LỊCH SỬ NHẬP - XUẤT THUỐC <Text color="orange.500" whiteSpace="preserve">{` ${medicine_name}`}</Text></Flex>
                </ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={6}>
                    {

                        (medicineImportExportList && medicineImportExportList.length !== 0) &&
                        <TableContainer width="100%" p={2}>
                            <Table variant="simple" size="sm">
                                <Thead>
                                    <Tr bg="#EAF0F0">
                                        <Th></Th>
                                        <Th>LOẠI</Th>
                                        <Th>NGÀY</Th>
                                        <Th>NHÀ CUNG CẤP/ĐƠN VỊ XUẤT</Th>
                                        <Th>GIÁ</Th>
                                        <Th>SỐ LƯỢNG</Th>
                                        <Th>NGƯỜI NHẬP/NGƯỜI XUẤT</Th>
                                        <Th>GHI CHÚ</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        medicineImportExportList && medicineImportExportList.map((item, idx) => {
                                            return (
                                                <Tr key={item.id}>
                                                    <Td>
                                                        <Text fontWeight="600">{idx + 1}</Text>
                                                    </Td>
                                                    <Td>
                                                        {
                                                            item.isImport &&
                                                            <Badge variant="solid" colorScheme='green'>NHẬP</Badge>
                                                        }
                                                        {
                                                            !item.isImport &&
                                                            <Badge variant="solid" colorScheme='orange'>XUẤT</Badge>
                                                        }
                                                    </Td>
                                                    <Td>
                                                        <Text fontWeight="600">
                                                            <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                                        </Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontWeight="600">{item.vendor}</Text>
                                                    </Td>
                                                    <Td>
                                                        { 
                                                            item.price &&
                                                            <Text fontWeight="600">
                                                                <FormattedNumber value={item.price}></FormattedNumber> VND
                                                            </Text>
                                                        }
                                                    </Td>
                                                    <Td>
                                                        <Text fontWeight="600">
                                                            { item.quantity && <FormattedNumber value={item.quantity}></FormattedNumber> }
                                                        </Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontWeight="600">{item.issued_by}</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontWeight="600">{item.description}</Text>
                                                    </Td>
                                                </Tr>
                                            )
                                        })
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    }
                    {
                        !medicineImportExportList || (medicineImportExportList && medicineImportExportList.length === 0) &&
                        <NoDataPage text="Hiện tại không có dữ liệu xuất nhập."/>
                    }
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default MedicineHistoryModal;